import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, FormHelperText, Typography, Checkbox } from '@mui/material';
import styled, { inputImages, inputNumbers, inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import { StudenMenu, Zones } from '../TitleList';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import { getCurrentDate } from '../../Utils/Dateutils';
import { fetchStudentData, insertStudenEntry, updateSchool } from '../../Store/PHPSlice/zone';
import { useParams } from 'react-router-dom';
import { selectLocations, selectStudents } from '../Selectors/Master/OutwardSelectors';
import { fetchLocationData } from '../../Store/PHPSlice/LocationApi';
import axios from 'axios';
import Dropdown from '../FieldsComponents/Dropdown';


const StudentEdit = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        studId: parseInt(Id),
        studNm: '',
        dt: '',
        div: '',
        std: '',
        age: '',
        ph: '',
        schlId: '',
        userId: userdata?.ID
    });
    const [schlList, setSchlList] = useState([]);
    const dispatch = useDispatch();
    const studentdata = useSelector(selectStudents);
    const schldata = useSelector(selectLocations);
    // console.log(studentdata)
    useEffect(() => {
        dispatch(fetchStudentData({ id: Id }));
        dispatch(fetchLocationData());
    }, [dispatch]);

    useEffect(() => {
        if (studentdata?.data) {
            const val = studentdata?.data;
            setFormData(prev => ({
                ...prev,
                studNm: val?.studNm,
                div: val?.div,
                ph: val?.ph,
                age: val?.age,
                std: val?.std,
                schlId: val?.schlId
            }));
        }
    }, [studentdata]);

    useEffect(() => {
        if (!userdata) return;

        if (userdata?.pageIds?.length > 0 && userdata?.role !== '1') {

            const selectpid = userdata?.pageIds?.filter(item => item === 1 || item === 2);
            if (selectpid?.length > 0) {
                const data = {
                    uid: userdata?.ID,
                    pageId: selectpid
                };
                fetchPageAssignSchools(data);
            }
        }

    }, []);

    const fetchPageAssignSchools = async (id) => {
        const { uid, pageId } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getUserwisePageIdSchools&uid=${uid}&pageId=${pageId}`);
            setSchlList(response?.data?.data);
            // console.log(response.data)

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        // if (formData.studNm === '') {
        //     alert('Please Enter Student Name');
        //     return;
        // }
        // if (formData.std === '') {
        //     alert('Please Enter Standard');
        //     return;
        // }
        // if (formData.div === '') {
        //     alert('Please Enter Division');
        //     return;
        // }
        dispatch(updateSchool(formData))
            .unwrap()
            .then((result) => {
                console.log('POST request successful!', result);
                alert("Student Updated");
                window.close();
            })
            .catch((error) => {
                console.error('Error while making POST request:', error);
            });
    };

    const isDesktop = useMediaQuery('(min-width:768px)');


    const fieldsecond = [
        // { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Student Name', name: 'studNm' },
        { label: 'Age', name: 'age' },
        { label: 'Standard', name: 'std' },
        { label: 'Division', name: 'div' },
        { label: 'Contact', name: 'ph' },
    ];

    const dropdownOrdType = [
        {
            label: 'School',
            id: 'schlId',
            options: userdata?.role !== '1' ? schlList : schldata?.data || [],
            value: formData.schlId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlId', value: newValue ? newValue.ID : '' } }, 'schlId'),
            getOptionLabel: (option) => option.schlcd || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true,
        }
    ];

    return (
        <>

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Student Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={1.2}>

                                {fieldsecond?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {
                                    dropdownOrdType?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                }


                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Update</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default StudentEdit;
